import { Pagination } from '@components/Pages/AnswersPage/constants';
import { UserEntityInterface, UserQueryInterface, UserMetadataResponseInterface } from '@types';

export type UserState = {
  currentUser: UserEntityInterface;
  users: UserEntityInterface[];
  total: number;
  usersFilters: Partial<UserQueryInterface>;
  metadata: UserMetadataResponseInterface;
};

export const initialUsersFilters: Partial<UserQueryInterface> = {
  offset: 0,
  limit: Pagination.USERS_ON_ADMIN_PAGE_COUNT_FIRST,
  withRoles: true,
};

export const userInitialState: UserState = {
  currentUser: null,
  users: [],
  total: 0,
  usersFilters: initialUsersFilters,
  metadata: null,
};
